<section-info></section-info>
<form>
    <div *ngFor="let documentType of visibleDocumentTypes">
        <div class="mt-8 mb-2">
            <h2 class="{{ (validateAttatchment(documentType)) ? 'form-label-error' : 'form-label'}}">
                {{ getDocumentTypeName(documentType) }} {{ isUploadRequired(documentType) ? ' *' : '' }}
            </h2>
            <div class="form-subtitle mt-3" [trimRichtextTitle]="getDocumentTypeInfoText(documentType)" [innerHTMLBypassXSS]="getDocumentTypeInfoText(documentType)"></div>
        </div>
        <p class="gemeinnuetzigkeitsBescheidInfotext" *ngIf="isGemeinnuetzigkeitsBescheidInfotextVisible(documentType)">{{gemeinnuetzigkeitsBescheidInfotext}}</p>
        <document-view class="document-view" (documentDelete)="onDocumentDelete($event)" (documentUpload)="onDocumentUpload($event)" [formControl]="attachmentForm" [documentType]="documentType"></document-view>
    </div>
</form>